import { CDN_URL, IMAGE_CDN_URL } from 'beek-design-system/utils/env';

export default {
  cdnUrl: CDN_URL,
  imageCdnUrl: IMAGE_CDN_URL,
  applestoreUrl:
    'https://apps.apple.com/mx/app/beek-descubre-mejores-libros/id1162867235',
  playstoreUrl: 'https://play.google.com/store/apps/details?id=com.beek',
};
